import React, { useEffect, useState, useRef } from "react";
// import { useSelector } from "react-redux";
import "@progress/kendo-react-intl";
import "@progress/kendo-react-dropdowns";
import "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import styles from "../../pages/Time/time.module.scss";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
    AmountFormatCell,
    BooleanCell,
    DateFormatCell,
    formatDateForAPI,
} from "components/common/formatter";
import AddTime from "pages/Time/AddTime";
import { HandleGridBody } from "components/common/HandleGridBody";
import { Popup } from "@progress/kendo-react-popup";
import FilterComponent from "../CaseFiles/FilterComponent";
import { FilterComponent as GeneraLFilters } from "components/common/FiltersComponent";
import { Skeleton } from "@progress/kendo-react-indicators";
import MattersCombobox from "pages/Postings/MattersComboBox";
import { Label } from "@progress/kendo-react-labels";
import { getAccessRightsData } from "services/currentUserService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { RedirectCell, GRID_PAGE_SIZES } from "components/common/GridComponents";
import { toast } from "react-toastify";
import { useCompany } from "services/companyService";

const statusData = [
    { key: "All", value: "" },
    { key: "Billed", value: true },
    { key: "UnBilled", value: false },
];

const CenterTextHeaderCell = (props) => (
    <th className="text-center border-0" style={{ width: "150px" }}>
        <span className=".k-cell-inner">
            <span className="k-link">
                <span className="k-column-title">{props.title}</span>
            </span>
        </span>
    </th>
);

export default function TimeRecorded(props) {
    const date = new Date();
    const [valueFrom, setValueFrom] = React.useState(false);
    const [valueTo, setValueTo] = React.useState(false);
    const [timeList, setTimeList] = useState({ data: [], total: 20 });
    const [isRefreshed, setIsRefreshed] = useState(false);
    const [eventDataState, setEventDataState] = React.useState();
    const [loadedContent, setLoadedContent] = useState(true);
    const [matterId, setMatterId] = useState(null);
    const [status, setStatus] = useState({ key: "All", value: "" });
    const [allowAccessData, setAllowAccessData] = useState({});
    const { data: company } = useCompany();
    const [viewTimeModal, setViewTimeModal] = useState(false);
    const [selectedTimeItem, setSelectedTimeItem] = useState(null);
    const [showAddTime, setShowAddTime] = useState(false);
    const [selectedMatter, setSelectedMatter] = useState(null);


    const [timeModal, setTimeModal] = useState({
        open: false,
        mode: "add",
        data: null,
    });

    const openAddTimeModal = (matter = null) => {
        setTimeModal({ open: true, mode: "add", data: matter });
    };

    const openEditTimeModal = (entry) => {
        if (entry?.billed) {
            toast.info("This time entry is already billed and cannot be viewed.");
            return;
        }
        setTimeModal({ open: true, mode: "edit", data: entry });
    };

    const closeTimeModal = () =>
        setTimeModal({ open: false, mode: "add", data: null });

    const handleRowClick = (dataItem) => openEditTimeModal(dataItem);

    // Check if the date is valid, otherwise, return a fallback (e.g., today's date or a default)
    let yearsStartDate = new Date(company.yearStartDate);
    if (isNaN(yearsStartDate)) {
        yearsStartDate = new Date(); // Fallback to today's date if the yearStartDate is invalid
    }

    const [fromDate, setFromDate] = useState(
        formatDateForAPI(yearsStartDate) // Extract the date part only if valid
    );
    const [toDate, setToDate] = useState(formatDateForAPI(date));
    const [updateFilter, setUpdateFilter] = useState(false);
    const [dataState, setDataState] = React.useState({
        take: 50,
        skip: 0,
        sort: [
            {
                field: "date",
                dir: "asc",
            },
        ],
    });

    // const handleRowClick = (dataItem) => {
    //   if (dataItem?.billed) {
    //     toast.info("This time entry is already billed and cannot be viewed.");
    //     return;
    //   }

    //   setSelectedTimeItem(dataItem);
    //   setViewTimeModal(true);
    // };

    const Redirect = (props) => (
        <RedirectCell handleClick={() => handleRowClick(props.dataItem)} />
    );

    const [fromDateSelector, setFromDateSelector] = useState(yearsStartDate);
    const [toDateSelector, setToDateSelector] = useState(date);

    useEffect(() => {
        if (props.refreshClicked && props.activeItem === 1) {
            ReloadData();
            props.setRefreshClicked(false);
        }

        if (props.addTime) {
            openAddTimeModal(props.matter || null);
            props.setAddTime(false); // optional reset from parent
        }
    }, [props.refreshClicked, props.addTime]);

    useEffect(() => {
        if (updateFilter) {
            setUpdateFilter(false);
        }
    }, [updateFilter]);

    const getAccessRights = async () => {
        try {
            const data = await getAccessRightsData();
            setAllowAccessData(data?.data?.data);
            setLoadedContent(false);
        } catch (error) { }
    };

    useEffect(() => {
        // if (!fromClient) {
        getAccessRights();
        // }
    }, []);

    const onChangeFromDateSelect = (event) => {
        if (!valueFrom) {
            setValueFrom(true);
        }
        setFromDateSelector(event.value);
        let fromDate = null;
        let date = new Date(event.value);
        if (event.value) {
            fromDate = formatDateForAPI(date);
        }
        setFromDate(fromDate);
    };

    const onChangeToDateSelect = (event) => {
        if (!valueTo) {
            setValueTo(true);
        }
        setToDateSelector(event.value);
        let toDate = null;
        let date = new Date(event.value);
        if (event.value) {
            toDate = formatDateForAPI(date);
        }
        setToDate(toDate);
    };

    const onChangematter = (e) => {
        let event = e.value;
        setMatterId(event);
        setSelectedMatter(event);
    };

    const updateFilterValues = () => {
        const { setFilterClicked, setFilterApplied } = props;
        setUpdateFilter(true);
        setFilterClicked(false);
        if (!valueFrom && !valueTo && status.value == "") {
            setFromDateSelector(yearsStartDate);
            setToDateSelector(date);
            setFilterApplied(false);
            return;
        }
        setFilterApplied(true);
    };

    const createState = (skip, take) => {
        let pagerSettings = {
            pageSizes: GRID_PAGE_SIZES,
        };
        return {
            pageSize: take,
            pageable: pagerSettings,
        };
    };

    const [state, setState] = React.useState(createState(0, 50));

    const blurTimeoutRef = useRef(null);

    const onOpen = () => {
        props?.filterContentRef?.current.focus();
    };

    const onFocus = () => {
        clearTimeout(blurTimeoutRef.current);
    };

    const onBlurTimeout = () => {
        props?.setFilterClicked(false);
    };

    const onBlur = () => {
        clearTimeout(blurTimeoutRef.current);
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
    };

    useEffect(() => {
        return () => {
            clearTimeout(blurTimeoutRef.current);
        };
    }, []);

    let handleChange = (e) => {
        setStatus(e.target.value);
    };

    const dataStateChange = (e) => {
        const eventObject = { event: e?.dataState };
        setEventDataState(eventObject);
        if (
            e.dataState.sort !== undefined &&
            e.dataState.skip !== 0 &&
            dataState.sort !== e.dataState.sort
        ) {
            setDataState({ ...e.dataState, skip: 0 });
        } else if (e.dataState.sort[0] === undefined) {
            setDataState({
                ...e.dataState,
                sort: [
                    {
                        field: dataState.sort[0].field,
                        dir: "asc",
                    },
                ],
            });
        } else {
            setDataState(e.dataState);
        }
        setUpdateFilter(true);
    };

    const handleReset = () => {
        setUpdateFilter(true);
        setValueFrom(false);
        setValueTo(false);
        setFromDateSelector(yearsStartDate);
        setToDateSelector(date);
        setStatus({ key: "All", value: "" });
        props.setFilterApplied(false);
        props.setFilterClicked(false);
    };

    const ReloadData = () => {
        if (eventDataState) {
            setDataState({ ...eventDataState?.event, skip: 0 });
        } else {
            setDataState({
                ...dataState,
                take: 50,
                skip: 0,
            });
        }
        setIsRefreshed(!isRefreshed);
        setUpdateFilter(true);
    };

    const dataReceived = (time) => {
        if (timeList) {
            setTimeList(time);
        }
    };

    const totalUnits = timeList?.data?.reduce(
        (acc, item) => acc + Number(item.units || 0),
        0
    );
    const totalValue = timeList?.data?.reduce(
        (acc, item) => acc + Number(item.value || 0),
        0
    );
    const totalBilledAmount = timeList?.data?.reduce(
        (acc, item) => acc + Number(item.billedNetAmount || 0),
        0
    );

    return (
        <div className={`h-100 w-100 d-flex flex-column ${props.className}`}>

            {props.fromCaseFile ? (
                <Popup
                    show={props?.filterClicked}
                    anchor={props?.filterAnchor?.current}
                    anchorAlign={{
                        horizontal: "right",
                        vertical: "bottom",
                    }}
                    popupAlign={{
                        horizontal: "right",
                        vertical: "top",
                    }}
                    popupClass={` ${styles["popup-content"]}  `}
                    onOpen={onOpen}
                >
                    <div
                        tabIndex={0}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        ref={props?.filterContentRef}
                        role="menu"
                        className="d-flex flex-column align-items-center"
                    >
                        <FilterComponent
                            updateFilterValues={updateFilterValues}
                            setUpdateFilter={setUpdateFilter}
                            updateFilter={updateFilter}
                            showPopup={true}
                            valueFrom={valueFrom}
                            setValueFrom={setValueFrom}
                            fromDateSelector={fromDateSelector}
                            onChangeFromDateSelect={onChangeFromDateSelect}
                            valueTo={valueTo}
                            setValueTo={setValueTo}
                            toDateSelector={toDateSelector}
                            onChangeToDateSelect={onChangeToDateSelect}
                            statusData={statusData}
                            status={status}
                            handleChange={handleChange}
                            handleReset={handleReset}
                            handleAddTime={() => openAddTimeModal(selectedMatter)}
                        />
                    </div>
                </Popup>
            ) : loadedContent ? (
                <Skeleton
                    shape="rectangle"
                    className="mb-3"
                    style={{
                        width: "100%",
                        height: "70px",
                    }}
                />
            ) : (
                <div className="d-flex align-items-end mb-3 flex-wrap flex-xl-nowrap  mx-auto gap-3">
                    <div className="d-flex align-items-end gap-2 flex-grow-1">
                        <GeneraLFilters
                            allowAccessData={allowAccessData}
                            updateFilters={(data) => { }}
                            isRefreshed={isRefreshed}
                            disabledFeeEarner={true}
                        />
                        <div className="flex flex-column">
                            <Label className="filter-font mb-1">Matter</Label>
                            <MattersCombobox
                                onChangematter={onChangematter}
                                value={matterId}
                                style={{ width: "250px", height: "40px" }}
                            />
                        </div>
                    </div>

                    <FilterComponent
                        valueFrom={valueFrom}
                        setValueFrom={setValueFrom}
                        fromDateSelector={fromDateSelector}
                        onChangeFromDateSelect={onChangeFromDateSelect}
                        valueTo={valueTo}
                        setValueTo={setValueTo}
                        toDateSelector={toDateSelector}
                        onChangeToDateSelect={onChangeToDateSelect}
                        statusData={statusData}
                        status={status}
                        handleChange={handleChange}
                        handleRefresh={ReloadData}
                        handleAddTime={() => openAddTimeModal(selectedMatter)}
                    />
                </div>
            )}

            <Grid
                {...dataState}
                data={timeList}
                onDataStateChange={dataStateChange}
                sortable={true}
                
                className="fs-md flex-grow-1 overflow-auto casefile_outlook_grid"
                pageable={state.pageable}
                pageSize={state.pageSize}
            >
                <GridColumn
                    field="date"
                    title="Date"
                    cell={DateFormatCell}
                    width="110px"
                />
                <GridColumn field="timeTypeCode" title="Type" width="80px" />
                <GridColumn field="feeEarnerRef" title="FE" width="80px" />
                <GridColumn field="matterRef" title="Matter Ref" width="120px" />
                <GridColumn field="details" title="Details" />
                <GridColumn
                    field="units"
                    title="Units"
                    width="70px"
                    className="text-center"
                    footerCell={() => (
                        <td className="fw-bold text-center ps-2">{totalUnits}</td>
                    )}
                />

                <GridColumn
                    field="rate"
                    title="Rate"
                    headerCell={CenterTextHeaderCell}
                    cell={AmountFormatCell}
                    width="80px"
                />
                <GridColumn
                    field="value"
                    title="Value"
                    headerCell={CenterTextHeaderCell}
                    cell={AmountFormatCell}
                    width="80px"
                    footerCell={() => (
                        <td className="fw-bold text-end pe-2">{totalValue?.toFixed(2)}</td>
                    )}
                />
                <GridColumn
                    field="billed"
                    className="ms-auto"
                    title="Billed"
                    headerCell={CenterTextHeaderCell}
                    cell={BooleanCell}
                    width="80px"
                />

                <GridColumn
                    field="billedNetAmount"
                    title="Bill Amt"
                    width="100px"
                    cells={{
                        data: AmountFormatCell,
                        headerCell: CenterTextHeaderCell,
                        footerCell: () => (
                            <td className="fw-bold text-end pe-2">
                                {totalBilledAmount?.toFixed(2)}
                            </td>
                        )
                    }}
                />

                <GridColumn width="60px" cells={{ data: Redirect }} />

            </Grid>

            {props?.fromCaseFile && (
                <HandleGridBody
                    matterId={props?.selectedMatterId}
                    refresh={isRefreshed}
                    updateFilter={updateFilter}
                    status={
                        updateFilter
                            ? status
                            : {
                                key: "All",
                                value: "",
                            }
                    }
                    fD={updateFilter && valueFrom ? fromDate : ""}
                    tD={updateFilter && valueTo ? toDate : ""}
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    currentComponent="timeRecorded-Matter"
                />
            )}
            {!props?.fromCaseFile && props?.parameter && (
                <HandleGridBody
                    feeEarner={props?.parameter}
                    refresh={isRefreshed}
                    status={status}
                    fD={valueFrom ? fromDate : ""}
                    tD={valueTo ? toDate : ""}
                    matterId={matterId?.matterId}
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    currentComponent="timeRecorded"
                />
            )}

            {timeModal.open && (
                <Dialog
                    title={timeModal.mode === "add" ? "Add Time" : "View Time Entry"}
                    onClose={closeTimeModal}
                >
                    <div style={{ width: "1000px", overflow: "hidden" }}>
                        <AddTime
                            component="modal"
                            fromCaseFile={true}
                            showModal={closeTimeModal}
                            mode={timeModal.mode}
                            initialData={timeModal.data}
                            matter={timeModal.mode === "edit" ? timeModal : timeModal.data}
                            cancelEdit={closeTimeModal}
                            fetchTime={ReloadData}
                        />
                    </div>
                </Dialog>
            )}
        </div>
    );
}
